/* eslint-disable no-unused-vars */
import React, { Fragment, useState } from 'react';
import EirPrequalForm from './EirPrequalForm';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../styles/theme';
import { prequalByData } from './EirPrequalIntegration';
import EirPrequalError from './EirPrequalError';
import EirPrequalResult from './EirPrequalResult.js';
import EirPrequalPhoneNumberForm from './EirPrequalPhoneNumberForm';
import { useLocalStorage, usePrequalCookie } from './EirPrequalPersistance';
import { getContext } from './EirPrequalUtil';
import PubSub from 'pubsub-js';

export default function EirPrequalDetailsContainer(props) {
    const [prequalEircodeForm, setPrequalEircodeForm] = useState(true);
    const [prequalPhoneNumberForm, setPrequalPhoneNumberForm] = useState(false);
    const [error, setError] = useState(null);
    const [prequalData, setPrequalData] = useState(null);
    const { setLocalStorage, getLocalStorage} = useLocalStorage();
    const {setCookie} = usePrequalCookie();
    const [loading, setLoading] = useState(false);
    const key = 'eir_prequal_data';

    const submitHandler = async (graphql, formData, flag, prequaled_by) => {
        let context = getContext();
        try {
            setLoading(true);
            const res = await prequalByData(graphql, formData, flag);
            if(flag ==='eircode'){
                setLocalStorage('ls_prequalby','eircode');
                setCookie('eir_prequal_user_location_type','address');            
            }
            else{
                setLocalStorage('ls_prequalby','phone');
                setCookie('eir_prequal_user_location_type','number');
            }
            
            let data = {};
            if (res) {
                (prequaled_by === 'Phone') ? data = res.prequalByPhone : data = res.prequalByEircode;
                if (data === null || data.maxDSL === null && data.maxFTCHSI === null && data.maxHSI === null && data.maxNBI === null && data.maxNGB === null ) {
                    setLoading(false);
                    return false;
                }else {
                    setLocalStorage('prequaled_By', prequaled_by);
                    setLocalStorage('prequaled_from', getLocalStorage('currentContext'));
                    setLocalStorage(key, {
                        ...formData,
                        ...{ 
                                prequalId: data.prequalid, fullAddress: data.fullAddress, 
                                eircode:data.eircode, phone:data.phone,
                                maxDSL: data.maxDSL, maxHSI: data.maxHSI, maxNGB: data.maxNGB, maxFTCHSI: data.maxFTCHSI,
                                maxNBI: data.maxNBI, ifth: data.ifth, iftc: data.iftc, inbi: data.inbi,ingb: data.ingb,
                                inga: data.inga, idsl: data.idsl, error: data.error, itv: data.itv,customerType: data.customerType
                                }
                    });
                    setLoading(false);
                    return true;
                }
            }
        } catch (err) {
            setLoading(false);
            if (prequaled_by === 'Phone')
            {
                setLocalStorage('phone', { areaCode: formData.areaCode, number: formData.number });
                        window.open(`/${context}/noresult/`, '_self');
            }
            else 
            {
                setLocalStorage('EIRCODE', formData.eirCode)
                PubSub.publish('PREQUAL_BYEIRCODE_FAILED_NETWORKERROR'); 
            }
            // setError(err.message);
        }
    };

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                {prequalEircodeForm && <EirPrequalForm submitHandler={submitHandler} resources={props} loading={loading}/>}
                {error && <EirPrequalError error={error} />}
                {prequalData && <EirPrequalResult data={prequalData} />}
                {prequalPhoneNumberForm && <EirPrequalPhoneNumberForm></EirPrequalPhoneNumberForm>}
            </ThemeProvider>
        </Fragment>
    );
}
